import { z } from 'zod'

export const geocodeDataSchema = z.object({
  feature_type: z.literal('district'),
  /**
   * The full address, e.g., Tazewell County, Illinois, United States
   * Human-readable combination of the district, region, and country
   */
  full_address: z.string(),
  context: z.object({
    /**
     * The country, e.g., United States
     */
    country: z.object({
      name: z.string(),
      /**
       * ISO 3166-1 alpha-2 country code
       */
      country_code: z.string()
    }),
    /**
     * The region (state, province, etc.), e.g., Illinois
     */
    region: z.object({
      name: z.string(),
      region_code: z.string(),
      region_code_full: z.string()
    }),
    /**
     * The district (county, etc.), e.g., Tazewell County
     */
    district: z.object({
      name: z.string()
    })
  })
})
